import { apiSend } from './_client';

export type ErrorSeverity = 'info' | 'warning' | 'error' | 'critical';

export interface ReportErrorInput {
  source?: string;
  message: string;
  severity?: ErrorSeverity;
  context?: Record<string, unknown> | null;
  job_id?: string | null;
  external_ref?: string | null;
}

/**
 * Report a client-side error to the admin Error Log. Best-effort: swallows its
 * own failures so error reporting never throws inside an error handler.
 */
export async function reportError(input: ReportErrorInput): Promise<void> {
  try {
    await apiSend('/api/errors/log', 'POST', { source: 'client', ...input });
  } catch {
    /* never throw from the reporter */
  }
}

/** Admin action — mark an error_log row resolved (or re-open it). */
export async function resolveError(id: string, resolved = true): Promise<{ ok: boolean; error?: string }> {
  return apiSend<{ ok: boolean; error?: string }>('/api/errors/resolve', 'POST', { id, resolved });
}
